import React from 'react';
import { TextInput } from '../../../../UI';
import styles from './TopKInput.module.scss';

interface TopKInputProps {
  topK: number;
  onChange: (topK: number) => void;
  min?: number;
  max?: number;
}

const TopKInput: React.FC<TopKInputProps> = ({ topK, onChange, min = 1, max = 200 }) => {
  const handleChange = (value: string) => {
    const numValue = parseInt(value, 10);
    if (!isNaN(numValue)) {
      // Ensure the value is within the min-max range
      const boundedValue = Math.min(Math.max(numValue, min), max);
      onChange(boundedValue);
    }
  };

  return (
    <div className={styles.topKInput}>
      <TextInput
        label="RAG K"
        type="number"
        min={min}
        max={max}
        value={topK.toString()}
        onChange={handleChange}
        fullWidth
        placeholder="Auto"
      />
    </div>
  );
};

export default TopKInput;
